var _rect, _g, _g2, _rect2, _path, _rect3, _circle, _circle2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComingSoonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 204,
    viewBox: "0 0 204 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 65,
    width: 114.4,
    height: 92.4,
    rx: 4.4,
    fill: "#E7E9EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 102.002,
    r: 48.4,
    fill: "#053668"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.998,
    y: 58,
    width: 114.4,
    height: 92.4,
    rx: 4.4,
    fill: "#073459"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7988,
    y: 55.8008,
    width: 114.4,
    height: 92.4,
    rx: 4.4,
    fill: "#1E95F8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7988 66.8008H159.199V143.801C159.199 146.231 157.229 148.201 154.799 148.201H49.1988C46.7688 148.201 44.7988 146.231 44.7988 143.801V66.8008Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.2
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 159.199,
    y: 64.6016,
    width: 2.2,
    height: 114.4,
    transform: "rotate(90 159.199 64.6016)",
    fill: "#053668"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7988 55.8008H159.199V66.8008H44.7988V55.8008Z",
    fill: "url(#paint1_linear)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.3992,
    cy: 60.2,
    r: 2.2,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.9988,
    cy: 60.2,
    r: 2.2,
    fill: "#80E1D6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.319 106.402C114.319 113.206 108.803 118.722 101.999 118.722C95.1952 118.722 89.6792 113.206 89.6792 106.402C89.6792 99.5974 95.1952 94.0816 101.999 94.0816C108.803 94.0816 114.319 99.5974 114.319 106.402ZM108.159 106.402C108.159 109.804 105.401 112.562 101.999 112.562C98.597 112.562 95.8392 109.804 95.8392 106.402C95.8392 102.999 98.597 100.242 101.999 100.242C105.401 100.242 108.159 102.999 108.159 106.402Z",
    fill: "#FEFCFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.319 106.402C114.319 113.206 108.803 118.722 101.999 118.722C95.1952 118.722 89.6792 113.206 89.6792 106.402C89.6792 99.5974 95.1952 94.0816 101.999 94.0816C108.803 94.0816 114.319 99.5974 114.319 106.402ZM108.159 106.402C108.159 109.804 105.401 112.562 101.999 112.562C98.597 112.562 95.8392 109.804 95.8392 106.402C95.8392 102.999 98.597 100.242 101.999 100.242C105.401 100.242 108.159 102.999 108.159 106.402Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.233 78.5278C97.3149 76.8885 98.6677 75.6016 100.309 75.6016H103.689C105.331 75.6016 106.684 76.8885 106.765 78.5278L106.867 80.5549C106.917 81.558 107.643 82.3898 108.611 82.6587C110.552 83.1979 112.396 83.9687 114.112 84.9393C114.986 85.4337 116.088 85.3591 116.832 84.6853L118.34 83.3213C119.557 82.2202 121.424 82.2668 122.584 83.4273L124.974 85.8176C126.135 86.9781 126.182 88.8449 125.08 90.0619L123.716 91.5697C123.043 92.3144 122.968 93.4159 123.462 94.29C124.433 96.0058 125.203 97.8497 125.742 99.7898C126.011 100.757 126.843 101.484 127.846 101.534L129.873 101.635C131.512 101.717 132.799 103.07 132.799 104.711V108.092C132.799 109.733 131.512 111.086 129.873 111.168L127.846 111.269C126.843 111.319 126.011 112.046 125.742 113.013C125.203 114.954 124.432 116.798 123.462 118.514C122.967 119.388 123.042 120.49 123.716 121.235L125.079 122.741C126.18 123.958 126.134 125.825 124.973 126.986L122.583 129.376C121.422 130.536 119.555 130.583 118.338 129.482L116.831 128.118C116.087 127.445 114.985 127.37 114.111 127.864C112.395 128.835 110.551 129.605 108.611 130.144C107.643 130.413 106.917 131.245 106.867 132.248L106.765 134.275C106.684 135.915 105.331 137.202 103.689 137.202H100.309C98.6677 137.202 97.3149 135.915 97.233 134.275L97.1317 132.248C97.0815 131.245 96.3552 130.413 95.3874 130.144C93.4472 129.605 91.6033 128.835 89.8875 127.864C89.0134 127.37 87.9118 127.445 87.1672 128.118L85.6608 129.481C84.4437 130.582 82.577 130.536 81.4168 129.375L79.0263 126.985C77.8657 125.825 77.819 123.958 78.9203 122.741L80.2829 121.235C80.9566 120.49 81.0312 119.388 80.5369 118.514C79.5662 116.798 78.7955 114.954 78.2563 113.013C77.9874 112.046 77.1557 111.319 76.1526 111.269L74.1254 111.168C72.4862 111.086 71.1992 109.733 71.1992 108.092V104.711C71.1992 103.07 72.4862 101.717 74.1254 101.635L76.1526 101.534C77.1557 101.484 77.9874 100.757 78.2563 99.7898C78.7955 97.8496 79.5661 96.0058 80.5365 94.2899C81.0309 93.4158 80.9562 92.3143 80.2824 91.5696L78.9188 90.0625C77.8179 88.8454 77.8645 86.9787 79.0252 85.8182L81.4153 83.4279C82.5759 82.2673 84.4426 82.2207 85.6597 83.3219L87.1664 84.6851C87.9111 85.3589 89.0126 85.4336 89.8868 84.9392C91.6029 83.9686 93.447 83.1979 95.3875 82.6587C96.3552 82.3898 97.0815 81.558 97.1317 80.5549L97.233 78.5278ZM120.479 106.402C120.479 116.608 112.205 124.882 101.999 124.882C91.793 124.882 83.5192 116.608 83.5192 106.402C83.5192 96.1953 91.793 87.9216 101.999 87.9216C112.205 87.9216 120.479 96.1953 120.479 106.402Z",
    fill: "#FEFCFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.233 78.5278C97.3149 76.8885 98.6677 75.6016 100.309 75.6016H103.689C105.331 75.6016 106.684 76.8885 106.765 78.5278L106.867 80.5549C106.917 81.558 107.643 82.3898 108.611 82.6587C110.552 83.1979 112.396 83.9687 114.112 84.9393C114.986 85.4337 116.088 85.3591 116.832 84.6853L118.34 83.3213C119.557 82.2202 121.424 82.2668 122.584 83.4273L124.974 85.8176C126.135 86.9781 126.182 88.8449 125.08 90.0619L123.716 91.5697C123.043 92.3144 122.968 93.4159 123.462 94.29C124.433 96.0058 125.203 97.8497 125.742 99.7898C126.011 100.757 126.843 101.484 127.846 101.534L129.873 101.635C131.512 101.717 132.799 103.07 132.799 104.711V108.092C132.799 109.733 131.512 111.086 129.873 111.168L127.846 111.269C126.843 111.319 126.011 112.046 125.742 113.013C125.203 114.954 124.432 116.798 123.462 118.514C122.967 119.388 123.042 120.49 123.716 121.235L125.079 122.741C126.18 123.958 126.134 125.825 124.973 126.986L122.583 129.376C121.422 130.536 119.555 130.583 118.338 129.482L116.831 128.118C116.087 127.445 114.985 127.37 114.111 127.864C112.395 128.835 110.551 129.605 108.611 130.144C107.643 130.413 106.917 131.245 106.867 132.248L106.765 134.275C106.684 135.915 105.331 137.202 103.689 137.202H100.309C98.6677 137.202 97.3149 135.915 97.233 134.275L97.1317 132.248C97.0815 131.245 96.3552 130.413 95.3874 130.144C93.4472 129.605 91.6033 128.835 89.8875 127.864C89.0134 127.37 87.9118 127.445 87.1672 128.118L85.6608 129.481C84.4437 130.582 82.577 130.536 81.4168 129.375L79.0263 126.985C77.8657 125.825 77.819 123.958 78.9203 122.741L80.2829 121.235C80.9566 120.49 81.0312 119.388 80.5369 118.514C79.5662 116.798 78.7955 114.954 78.2563 113.013C77.9874 112.046 77.1557 111.319 76.1526 111.269L74.1254 111.168C72.4862 111.086 71.1992 109.733 71.1992 108.092V104.711C71.1992 103.07 72.4862 101.717 74.1254 101.635L76.1526 101.534C77.1557 101.484 77.9874 100.757 78.2563 99.7898C78.7955 97.8496 79.5661 96.0058 80.5365 94.2899C81.0309 93.4158 80.9562 92.3143 80.2824 91.5696L78.9188 90.0625C77.8179 88.8454 77.8645 86.9787 79.0252 85.8182L81.4153 83.4279C82.5759 82.2673 84.4426 82.2207 85.6597 83.3219L87.1664 84.6851C87.9111 85.3589 89.0126 85.4336 89.8868 84.9392C91.6029 83.9686 93.447 83.1979 95.3875 82.6587C96.3552 82.3898 97.0815 81.558 97.1317 80.5549L97.233 78.5278ZM120.479 106.402C120.479 116.608 112.205 124.882 101.999 124.882C91.793 124.882 83.5192 116.608 83.5192 106.402C83.5192 96.1953 91.793 87.9216 101.999 87.9216C112.205 87.9216 120.479 96.1953 120.479 106.402Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0.799614,
    y: 0.801567,
    width: 202.4,
    height: 202.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 40.398,
    y: 51.4,
    width: 127.6,
    height: 105.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.3,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 67.8992,
    y: 72.3016,
    width: 70.4,
    height: 70.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.1,
    dy: 1.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 44.7988,
    y1: 66.8008,
    x2: 161.922,
    y2: 76.0109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 101.999,
    y1: 55.8008,
    x2: 101.999,
    y2: 66.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 71.203,
    y1: 75.6016,
    x2: 117.071,
    y2: 147.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 71.203,
    y1: 75.6016,
    x2: 117.071,
    y2: 147.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoonIcon);
export default __webpack_public_path__ + "static/media/coming-soon-icon.e79d54a3.svg";
export { ForwardRef as ReactComponent };